/**
 * @generated SignedSource<<55412456aa9830caad4092186b710e1a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedTopHeroBannerModule_componentModule$data = {
  readonly messages: {
    readonly items: ReadonlyArray<{
      readonly cta: string | null;
      readonly heroBannerSettings: {
        readonly backgroundColor: string | null;
        readonly contentColor: string | null;
        readonly dekText: string | null;
        readonly eyeBrowText: string | null;
        readonly headerText: string | null;
      } | null;
      readonly imageHeight?: string | null;
      readonly imageUrl?: string | null;
      readonly imageWidth?: string | null;
      readonly isMuxVideo: boolean | null;
      readonly linkData: {
        readonly path: string | null;
      };
      readonly mediaFormat: string | null;
      readonly mobileImageHeight?: string | null;
      readonly mobileImageUrl?: string | null;
      readonly mobileImageWidth?: string | null;
      readonly videoAutoplay: boolean | null;
      readonly videoUrl: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "HpSharedTopHeroBannerModule_componentModule";
};
export type HpSharedTopHeroBannerModule_componentModule$key = {
  readonly " $data"?: HpSharedTopHeroBannerModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedTopHeroBannerModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedTopHeroBannerModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "TopHeroBannerMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TopHeroBannerItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "condition": "isMobile",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageHeight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageWidth",
                  "storageKey": null
                }
              ]
            },
            {
              "condition": "isMobile",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileImageUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileImageHeight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mobileImageWidth",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "HeroBannerSettingsType",
              "kind": "LinkedField",
              "name": "heroBannerSettings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eyeBrowText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "headerText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dekText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "backgroundColor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentColor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cta",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMuxVideo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoAutoplay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mediaFormat",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TopHeroBannerModule",
  "abstractKey": null
};

(node as any).hash = "71873d9e421fd6c81a58fa07172f889e";

export default node;
